import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { injectIntl, defineMessages } from 'react-intl'
import { compose } from 'recompose'
import { followUser } from '../../common/users/actions'
import { Button } from './'

class UsersList extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      savedUsers: [],
    }
  }

  saveUser(userId) {
    this.setState({
      savedUsers: [...this.state.savedUsers, userId],
    })
    this.props.followUser(userId)
  }

  render() {
    const { users, intl } = this.props
    const { savedUsers } = this.state

    return (
      <div className="users-list">
        {
          users.map(u => (
            <div key={u._id} className="item-box">
              <Link to={`/app/user/${u._id}`}>{u.name} - {u.email}</Link>
              <div className="float-right">
                <Button
                  positive
                  onClick={() => this.saveUser(u._id)}
                  disabled={savedUsers.includes(u._id)}
                >
                  {intl.formatMessage(messages.follow)}
                </Button>
              </div>
            </div>
          ))
        }
      </div>
    )
  }
}

UsersList.defaultProps = {
  users: [],
}

UsersList.propTypes = {
  intl: PropTypes.object.isRequired,
  users: PropTypes.array,
  followUser: PropTypes.func.isRequired,
}

const enhance = compose(
  connect(() => ({ }), { followUser }),
  injectIntl,
)

export default enhance(UsersList)

const messages = defineMessages({
  follow: {
    id: 'users.list.follow',
    defaultMessage: 'Sledovať',
  },
})



// WEBPACK FOOTER //
// ./src/browser/components/UsersList.js